export default "__VITE_ASSET__W1z1QOBY__"